module.exports = __webpack_public_path__ + "img/activity-effect.05391331.png";